import React, { useCallback } from 'react'
import {
  AddressDTO,
  AddressFormContextProvider,
  AddressFormLabelsType,
  useConfigState,
  useUIFunctions,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'

import { Modal } from '../..'
import { AddressForm } from '../../AddressBook/AddressForm'
import { Button } from '../../Button'

export type AddressFormModalProps = {
  address?: AddressDTO
  errorLabels: AddressFormLabelsType
}

export const AddressFormModal = ({
  address,
  errorLabels,
}: AddressFormModalProps) => {
  const { closeViewById } = useUIFunctions()
  const config = useConfigState()
  const labels = useGlobalLabels()
  const close = useCallback(() => {
    closeViewById(config.views.addressForm)
  }, [closeViewById, config])

  return (
    <Modal open noTitlePadding fullOnMobile handleClose={close}>
      <AddressFormContextProvider
        address={address}
        onSuccess={close}
        errorLabels={errorLabels || {}}
      >
        <AddressForm />
        <div className="d-flex align-items-center">
          <Button
            type="submit"
            variant="green"
            borderRadius="small"
            small
            className="mr-3"
          >
            {labels?.save}
          </Button>
          <Button
            onClick={close}
            bordered
            borderRadius="small"
            variant="green"
            small
          >
            {labels?.close}
          </Button>
        </div>
      </AddressFormContextProvider>
    </Modal>
  )
}
